import { useContext } from 'react';
import { MotionPathContext, MotionPathState } from './MotionPathContext';

export const useMotionPath = (): MotionPathState => {
  const context = useContext(MotionPathContext);
  if (!context)
    throw new Error('useMotionPath hook must be used in a MotionPathControls component.');
  return context;
};
